import axiosInstance from "core/api/axiosInstance";

export const getIndicadores = async ({ signal, onDownloadProgress } = {}) => {
  try {
    const { data } = await axiosInstance.get(`/api/indicator/get/indicator/glpi`, {
      signal,
      onDownloadProgress,
      responseType: "text",
      // Evita que Axios interprete un JSON masivo en el hilo de la interfaz.
      transformResponse: [(response) => response],
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener indicadores");
  }
};
